import React from 'react';
import util from '../util/util';
import 'babel-polyfill';

export default class Plans extends React.Component {
	constructor(props) {
		super(props);
		
		this.state = {
			planData: [
				{
					planType: 'Free Beta',
					plan: 'Shop Plan',
					price: '$0.00',
					prevPrice: null,
					unlimited: true,
					freeAds: false,
					percentCollected: 3.8,
					store: false,
					planTypeID: 5
				}/*,
				{
					planType: 'BETA',
					plan: 'Expert Plan',
					price: '$5.99',
					prevPrice: '$9.99',
					unlimited: true,
					freeAds: true,
					percentCollected: 3.2,
					store: true,
					planTypeID: 7
				}*/
			],
			isHome: util.IsDefined(this.props.home)
		}
	}
	
	render() {
		let classes = this.state.planData.length == 1 ? 'col-4 clearfix' : 'col-7 clearfix';
		return(
			<section className="clearfix animate-slide">
				<h2 className="text-centered">Select a Pricing Plan<br />
					<span className="subTitle">We have pricing plans to suite everyones needs.</span>
				</h2>
				<br />
				<div className={classes} id="pricingContent">
					{this.state.planData.map(this.createPlans.bind(this))}
				</div>
			</section>
		)
	}
	
	handleState(plan) {
		this.props.handleChange('PlanType', plan.planTypeID)
		this.props.changeSection('shop', 2)
	}

	createPlans(plan, i) {
		let classes = this.state.planData.length == 1 ? 'col-12 clearfix' : 'col-6 clearfix'
		let prev = plan.prevPrice != null ? <strike style={{color: '#e1e1e1'}}>{plan.prevPrice}</strike> : '';
		let freeAds = !plan.freeAds ? <strike>$10 free WUBART Ads/month</strike> : '$10 free WUBART Ads\/month';
		let store = !plan.store ? 'Custom Storefront with a friendly URL' : 'Personalized Storefront with a friendly URL';
		let buttonClick = this.state.isHome ? () => {window.location.href = '/signup.cfm'} : this.handleState.bind(this, plan);
		let buttonText = this.state.isHome ? 'Create Account' : 'Select Plan';
		return (
			<div key={i} className={classes}>
				<div className="pricingBox col-12 white" style={{padding:0}}>
					<table cellPadding="0" cellSpacing="0" border="0" className="pricingTables">
						<tbody>
							<tr>
								<td>
									<h3><span>{plan.planType}</span> {plan.plan}</h3>
								</td>
							</tr>
							<tr>
								<td className="accountFees">{prev} {plan.price}/month</td>
							</tr>
							<tr>
								<td>
									<strong>Unlimited Items</strong><br/> (no per item charge)
								</td>
							</tr>
							<tr>
								<td>
									<strong>{freeAds}</strong>
								</td>
							</tr>
							<tr>
								<td>
									<strong>We collect {plan.percentCollected}% + 30&cent; on your items sale price</strong>
								</td>
							</tr>
							<tr>
								<td>
									<strong>{store}</strong><br /> <span>COMING SOON</span>
								</td>
							</tr>
							<tr>
								<td>
									<button type="button" className="btn btn-pink" onClick={buttonClick.bind(this)}>{buttonText}</button>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
		)
	}
}


/** WEBPACK FOOTER **
 ** ./app/reusable/pricing.js
 **/